export default "__VITE_ASSET__BENLw2_O__"